import { API, authClient } from "../index";
import { getSessionUUID } from "../../utils/helpers";

export const voteProducto = async (eventoId, categoriaIndex, productoIndex) => {
  const sessionUUID = getSessionUUID();
  return authClient().post(`${API}/productoVoto/vote`, {
    eventoId,
    categoriaIndex,
    productoIndex,
    sessionUUID,
  });
};

export const getProductoVotes = async (eventoId) => {
  return authClient().get(`${API}/productoVoto/event/${eventoId}`);
};

export const checkProductoVote = async (eventoId, categoriaIndex, productoIndex) => {
  const sessionUUID = getSessionUUID();
  return authClient().get(`${API}/productoVoto/check`, {
    params: { eventoId, categoriaIndex, productoIndex, sessionUUID },
  });
};

export const getUserVotes = async (eventoId) => {
  const sessionUUID = getSessionUUID();
  return authClient().get(`${API}/productoVoto/user/${eventoId}`, {
    params: { sessionUUID },
  });
};

